import React from "react";
import { Box, Typography } from "@mui/material";
import typography from "../cssUtils/typography";

/**
 * StatTile — a number with a caption.
 * By default the value is on top and the label below. Pass `labelFirst` to put the label above
 * the value ("Total members" then "9"). Other pages rely on the default.
 */
const StatTile = ({ value, label, valueColor = "#1D2330", labelFirst = false, sx = {} }) => {
  const valueText = (
    <Typography sx={{ ...typography.h2, fontWeight: 700, color: valueColor, lineHeight: 1.2 }}>
      {value}
    </Typography>
  );
  const labelText = (
    <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", ...(labelFirst ? { mb: 0.25 } : { mt: 0.25 }) }}>
      {label}
    </Typography>
  );

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 120,
        border: "1px solid #E5E7EB",
        borderRadius: "10px",
        backgroundColor: "#fff",
        px: 2,
        py: 1.5,
        ...sx,
      }}
    >
      {labelFirst ? labelText : valueText}
      {labelFirst ? valueText : labelText}
    </Box>
  );
};

export default StatTile;
